import {useRouteQuery} from '@github-ui/react-core/future/use-route-query'
import {useAssigneesLiveUpdates} from '../../../hooks/use-assignees-live-updates'
import {pullRequestsLayoutRoute} from '../../../routes/layout-route'
import {useAssigneesQuery} from './route-queries'

export function useAssignees() {
  const {data: layoutData} = useRouteQuery(pullRequestsLayoutRoute, 'mainQuery')
  useAssigneesLiveUpdates(layoutData?.aliveChannels)

  return useAssigneesQuery()
}
